import { render, staticRenderFns } from "./ApopBar.vue?vue&type=template&id=44570fd6&"
import script from "./ApopBar.vue?vue&type=script&lang=js&"
export * from "./ApopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports